import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'snap-angular-lib',
  template: `
    <p>
      snap-angular-lib works!
    </p>
  `,
  styles: []
})
export class SnapAngularLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
